// The red pen (docs/13 "Identity"): a hand-drawn circle, underline or strike over a word, drawn
// in once when the word appears. It is how the site marks what matters, as a teacher marks work.
import clsx from "clsx";
import type { ReactNode } from "react";

const PATHS = {
  circle: "M6 32 C 2 12, 60 3, 140 6 C 196 9, 199 40, 160 50 C 110 60, 20 58, 8 40 C 2 30, 20 14, 62 9",
  underline: "M3 52 C 40 45, 100 46, 197 49",
  strike: "M2 34 C 50 28, 120 36, 198 26",
  double: "M3 50 C 50 44, 120 47, 197 46 M12 56 C 70 52, 130 55, 190 53",
} as const;

export type PenKind = keyof typeof PATHS;

export function RedPen({ children, kind = "underline", delay = 0.25, className }: { children: ReactNode; kind?: PenKind; delay?: number; className?: string }) {
  return (
    <span className={clsx("relative inline-block whitespace-nowrap", className)}>
      <span className="relative z-[1]">{children}</span>
      <svg
        viewBox="0 0 200 60"
        preserveAspectRatio="none"
        aria-hidden
        className={clsx("pointer-events-none absolute z-[2] overflow-visible text-signal", kind === "circle" ? "-inset-x-[8%] -inset-y-[18%] h-[136%] w-[116%]" : "inset-x-0 -bottom-[0.05em] top-0 h-full w-full")}
      >
        <path d={PATHS[kind]} pathLength={1} fill="none" stroke="currentColor" strokeWidth={kind === "circle" ? 3.2 : 4.5} strokeLinecap="round" className="ocs-pen" style={{ animationDelay: `${delay}s` }} vectorEffect="non-scaling-stroke" />
      </svg>
    </span>
  );
}
